<template>
  <v-app class="app-layout">
    <v-toolbar dark class="toolbar" v-if="user.flowType!='mts' && user.flowType!='mvm'">
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
      <v-toolbar-title class="white--text">
        <span></span>
        <v-btn
          :key="title"
          @click="navigate('buy-phones')"
          flat>Телекоминвест <span>/ {{ user ? user.name : 'Гость' }}</span>
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items class="hidden-sm-and-down"> -->
        <v-toolbar-items>

        <v-btn
          v-for="item in routes"
          :key="item.route"
          @click="navigate(item.route)"
          flat>{{ item.text }}
        </v-btn>
      </v-toolbar-items>
      <!-- <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list>
          <v-list-tile v-for="item in routes" :key="item.route">
            <v-list-tile-content>
              <v-list-tile-title @click="navigate(item.route)">{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu> -->
      <!-- <span>
        {{ user ? user.name : 'Гость' }}
      </span> -->
      <v-btn icon flat @click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>

    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <slot/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    props: {
      title: String,
    },
    computed: {
      ...mapState('user', ['user']),
      routes() {
        const routes = [
          // {
          //   text: 'Главная',
          //   route: 'home',
          // },
          
        ];
        // shops
        if (this.user && this.user.type == 1) {
          routes.push({
            text: 'Trade In',
            route: 'buy-phones',
          });
          // routes.push({
          //   text: 'Часы',
          //   route: 'apple-watch',
          // });
          routes.push({
            text: 'Заявки',
            route: 'orders',
          },)
        }

        // managers и administrators
        if (this.user && this.user.type >= 2) {
          routes.push({
            text: 'Логистика',
            route: 'stores',
          },
          {
            text: 'Выкупы',
            route: 'ransoms',
          });
          // routes.push({
          //   text: 'Статистика',
          //   route: 'summary',
          // });
        }

        return routes;
      },
    },
    methods: {
      ...mapMutations('user', ['USER_LOGOUT']),

      navigate(route) {
        if (this.$router.history.current.name != route) {
          this.$router.push({ name: route });
        }else{
          this.$router.go(this.$router.currentRoute)
        }
      },
      logout() {
        this.USER_LOGOUT();
        this.$router.push({ name: 'login' });
      },
    },
  };
</script>

<style>
  .app-layout {
    background: #E1E1E1 !important;
  }
</style>
